class HrController implements ng.IComponentController {
    static $inject = [];
    constructor() {
        // console.log('HrController');
    }
}

export const hrComponent : ng.IComponentOptions = {
    controller : HrController,
    template : require('./hr.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/hr.component.ts